import { PayloadAction } from "@reduxjs/toolkit";
import { push } from "connected-react-router";
import { call, put, select, takeEvery } from "redux-saga/effects";
import { ModifierGroup } from "../generated-interfaces/graphql";
import { MENU_EDITOR_ROUTES } from "../pages/menu-editor/menu-editor-routes";
import { duplicateModifierGroup, getMenu } from "../reducers/menuReducer";
import { selectedRestaurantCodeSelector } from "../selectors/restaurant";
import { IDuplicatePayload } from "../types/menu";
import logger from "../utils/logger";
import { getSdk } from "../utils/network";
import { PerfTimer } from "../utils/timer";
import { getAuthInfo } from "./utilsSaga";

function* duplicateModifierGroupSaga(action: PayloadAction<IDuplicatePayload>) {
    const timer = new PerfTimer();
    logger.debug("Duplicating Modifier Group");
    const { token, isAuth0 } = yield call(getAuthInfo);
    const sdk = getSdk(token, isAuth0);
    const {
        id: sourceModifierGroupId,
        successCallback,
        errorCallback,
    } = action.payload;
    try {
        const restaurantCode: string = yield select(
            selectedRestaurantCodeSelector
        );

        const dupModifierGroupResponse: {
            duplicateModifierGroup: ModifierGroup;
        } = yield sdk.duplicateModifierGroup({
            restaurantCode,
            sourceModifierGroupId,
            version: 0,
        });

        yield put(
            push(
                MENU_EDITOR_ROUTES(restaurantCode)[
                    "duplicateModifierGroup"
                ].path.replace(
                    ":id",
                    dupModifierGroupResponse.duplicateModifierGroup.id
                )
            )
        );

        yield put(getMenu());
        successCallback?.();
        logger.info("Duplicate Modifier Group successful", {
            duration: timer.stop(),
        });
    } catch (error) {
        errorCallback?.();
        logger.error("Duplicate Modifier Group failed", {
            error,
            duration: timer.stop(),
        });
    }
}

export default function* modifierGroupSaga() {
    yield takeEvery(
        duplicateModifierGroup.toString(),
        duplicateModifierGroupSaga
    );
}
